import { useTranslation } from "react-i18next"
import { Stack, Typography } from "@mui/material"

import type { UserOTPRecoverCodes } from "types/users.types"
import PopUp from "widgets/common/PopUp"
import OTPRecoverCodes from "./OTPRecoverCodes"

interface OTPRecoverCodesModalProps {
  open: boolean
  onClose: () => void
  username: string
  data: UserOTPRecoverCodes | undefined
}

const OTPRecoverCodesModal = ({ open, onClose, data }: OTPRecoverCodesModalProps) => {
  const { t } = useTranslation()
  return (
    <PopUp
      open={open}
      onClose={onClose}
      titleKey="account_settings.ACCOUNT_RECOVERY_CODES"
      aria-describedby="otp-codes-description"
      fullWidth
      maxWidth={"md"}
    >
      <Stack id="otp-register-description" width={"100%"}>
        <Typography mb={1}>{t("account_settings.IF_LOSE_KEYS")}</Typography>
        <Typography mb={1}>{t("account_settings.CODES_PURPOSE")}</Typography>
        <Typography mb={1}>{t("account_settings.CODES_DISCLAIMER")}</Typography>
      </Stack>
      {data && (
        <Stack alignItems={"center"} width={"100%"}>
          <OTPRecoverCodes codes={data} />
        </Stack>
      )}
    </PopUp>
  )
}

export default OTPRecoverCodesModal
